import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import React, { FunctionComponent } from 'react';

export type AwayWindow = { coverageStartDate: string; coverageEndDate: string };

export type AvailabilityProps = (
  | { availableWeekdays: number[]; availableDates?: string[] }
  | { availableWeekdays?: number[]; availableDates: string[] }
) & { awayWindows: AwayWindow[] };

type CalendarDayProps = PickersDayProps<DateTime> & AvailabilityProps;

export const CalendarDay: FunctionComponent<CalendarDayProps> = ({
  availableWeekdays,
  availableDates,
  awayWindows,
  ...rest
}) => {
  const isTodayOrFuture = DateTime.now().startOf('day') <= rest.day;
  const dayIsoDate = rest.day.toISODate();

  const isDayInAvailabilitySet = availableDates
    ? !!dayIsoDate && availableDates.includes(dayIsoDate)
    : (availableWeekdays ?? []).includes(rest.day.weekday);

  const isAway = awayWindows.some(
    ({ coverageStartDate, coverageEndDate }) =>
      coverageStartDate <= dayIsoDate && dayIsoDate <= coverageEndDate,
  );

  // `disabled` below replaces the picker's own gating, so fold `rest.disabled` back in.
  const mayHaveAvailability =
    isTodayOrFuture && isDayInAvailabilitySet && !isAway && !rest.disabled;

  return (
    <PickersDay
      data-cy={!mayHaveAvailability ? 'calendar-day-disabled' : 'calendar-day'}
      {...rest}
      sx={
        mayHaveAvailability
          ? {
              bgcolor: (theme) => theme.palette.primary.lighter,
              transition: 'background-color 0.2s',
              color: (theme) => theme.palette.primary.main,
              fontWeight: 'bold',
            }
          : {}
      }
      disabled={!mayHaveAvailability}
    />
  );
};
